export default "__VITE_ASSET__AItb2azL__"